import {useAuth} from '@apps-common/auth-react';
import AppsDropdown from '@apps-common/ui-components/NavBar/AppsDropdown.jsx';
import HelpMenu from '@apps-common/ui-components/NavBar/HelpMenu.jsx';
import NavBar from '@apps-common/ui-components/NavBar/NavBar.jsx';
import {NavButton} from '@apps-common/ui-components/NavBar/NavMenuButton.jsx';
import SettingsIcon from '@mui/icons-material/Settings';
import {Box, Chip, Tooltip} from '@mui/material';
import {pink, purple} from '@mui/material/colors';
import React, {useCallback, useState} from 'react';
import {useMatch} from 'react-router';
import urls from '@api/urls';
import SettingsSidebar from '@components/sidebars/settings/SettingsSidebar.jsx';
import {reset as resetAnalytics, trackEvent} from '@src/analytics';
import {DEPLOY_ENV} from '@src/config';
import {ANALYZE_ROOT_ROUTE} from '@src/constants/routes';

const EnvironmentChip = () => {
  if (
    window.location.hostname === 'www.planet.com' ||
    window.location.hostname === 'insights.planet.com'
  ) {
    return false;
  }

  const label = import.meta.env.DEV
    ? 'Local'
    : window.location.pathname.startsWith('/acorns/live/main')
      ? 'Internal'
      : 'Branch';

  const tooltipText = `API base: ${urls.base}`;

  return (
    <Tooltip title={tooltipText}>
      <Chip
        label={label}
        shape="square"
        size="small"
        sx={{
          backgroundColor: import.meta.env.DEV ? purple[500] : pink[500],
        }}
      />
    </Tooltip>
  );
};

const TopNavBar = () => {
  const auth = useAuth();
  const [settingsOpen, setSettingsOpen] = useState(false);

  const logout = useCallback(() => {
    trackEvent('Logout Button clicked');

    resetAnalytics();

    auth.signOut();
  }, [auth]);

  const isAnalyze = useMatch(`${ANALYZE_ROOT_ROUTE}/*`);
  const appKey = isAnalyze ? 'analyze' : 'data';

  return (
    <>
      <NavBar
        title={<AppsDropdown appKey={appKey} environment={DEPLOY_ENV} />}
        user={auth.user?.claims}
        secondary={
          <>
            <Box sx={{marginInlineEnd: 1.2}}>
              <EnvironmentChip />
            </Box>

            <HelpMenu />

            <NavButton
              aria-label="Settings"
              onClick={() => setSettingsOpen(true)}
            >
              <SettingsIcon fontSize="small" />
            </NavButton>
          </>
        }
        logout={logout}
        sx={{zIndex: 'modal'}}
        environment={DEPLOY_ENV}
        className="pl-mode-dark"
      />

      <SettingsSidebar
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      />
    </>
  );
};

export default TopNavBar;
